<template>
  <div class="flex justify-between items-center border-b border-gray-200 py-2 last:border-none">
    <div>
      <div><strong>{{ consumer.name }}</strong></div>
      <FeedbackInformation :feedbacks="consumer.feedbacks" />
      <SettingsInformation :settings="consumer.settings" />
    </div>
    <BaseButton
      :loading="state.loading"
      :primary="true"
      :disabled="state.unmasked"
      @click="deleteFeedbacksAndSettings()"
    >
      {{ state.unmasked ? "Patient réintégré" : "Réintégrer le patient" }}
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
import {reactive} from "vue";
import BaseButton from '@/core/components/base/BaseButton.vue';
import {programApi} from '@/container';
import {Feedback, Program, SupportProgramConsumerSettings, SupportProgramPatient} from "@/program/interfaces/Program";
import FeedbackInformation from "@/consumer/components/consumer-programs/FeedbackInformation.vue";
import SettingsInformation from "@/consumer/components/consumer-programs/SettingsInformation.vue";

const props = defineProps<{
    consumer: SupportProgramPatient;
    program: Program;
}>();

const state = reactive({
    unmasked: false,
    loading: false,
});

const emit = defineEmits(['unmasked']);

/**
 * Delete the program inclusion (in API).
 */
const deleteFeedbacksAndSettings = async () => {
    state.loading = true;
    const feedbackPromises = props.consumer.feedbacks?.map((feedback: Feedback) => {
        return programApi().deleteFeedback(props.program.id, feedback.id);
    }) ?? [];

    const settingPromises = props.consumer.settings?.map((setting: SupportProgramConsumerSettings) => {
        return programApi().updateConsumerSettings(setting.id, {disabled: false});
    }) ?? [];

    if (feedbackPromises.length || settingPromises.length) {
        await Promise.all([
            ...feedbackPromises,
            ...settingPromises,
        ]);
    }

    state.loading = false;
    state.unmasked = true;
    emit('unmasked', props.consumer);
};
</script>
